export default "__VITE_PUBLIC_ASSET__10865157__"